import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { Layout, Hero, About, Activities, Contact } from '@components';

const StyledMainContainer = styled.main`
  counter-reset: section;
  padding-top: 150px;

  #about {
    padding-top: 40px;
    padding-bottom: 80px;
  }

  #activities {
    padding-top: 60px;
  }

  @media (max-width: 768px) {
    padding-top: 120px;
  }
`;

const IndexPage = ({ location }) => (
  <Layout location={location}>
    <StyledMainContainer>
      <Hero />
      <About />
      <Activities />
      <Contact />
    </StyledMainContainer>
  </Layout>
);

IndexPage.propTypes = {
  location: PropTypes.object.isRequired,
};

export default IndexPage;
